<template>
    <div class="content-page">
        <div class="tab-header">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/message' }">消息中心</el-breadcrumb-item>
                <el-breadcrumb-item>消息详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="tab-content" v-if="messageInfo">
            <p class="title">{{messageInfo.newsTitle}}</p>
            <p class="create-time">{{messageInfo.createTime}}</p>
            <div class="content" v-html="messageInfo.newsContent"></div>
        </div>
    </div>
</template>

<script>
import { getShopNoticeInfo, getShopNotices } from "@/api/index.js";
import { mapActions } from "vuex";

export default {
    data() {
        return {
            messageInfo: null
        };
    },
    created() { },
    mounted() {
        getShopNoticeInfo({
            id: this.$route.query.newsId
        }).then(res => {
            if (res.code == 1) {
                this.messageInfo = res.data;
                getShopNotices({
                    row: 1000
                }).then(noticeRes => {
                    if (res.code == 1) {
                        this.updateMessage(noticeRes.data);
                    }
                })
            }
        });
    },
    methods: {
        ...mapActions(["updateMessage"])
    }
};
</script>

<style lang="less" scoped>
.content-page {
    .tab-content {
        display: block;
        padding: 20px;
        .title {
            font-size: 24px;
            color: #333333;
            margin-top: 10px;
            line-height: 24px;
        }
        .create-time {
            font-size: 12px;
            color: #999999;
            line-height: 12px;
            margin-top: 10px;
            margin-bottom: 30px;
        }
    }
}
</style>
